import { render, staticRenderFns } from "./IconStyles.vue?vue&type=template&id=4f7096c8&scoped=true&lang=pug&"
import script from "./IconStyles.vue?vue&type=script&lang=ts&"
export * from "./IconStyles.vue?vue&type=script&lang=ts&"
import style0 from "./IconStyles.vue?vue&type=style&index=0&id=4f7096c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7096c8",
  null
  
)

export default component.exports